/* eslint-disable no-sequences */
/* eslint-disable array-callback-return */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const columns = [
  {
    id: "hash",
    label: "#",
    minWidth: 10,
  },
  {
    id: "nome",
    label: "Nome do Usuário",
    minWidth: 100,
  },
  {
    id: "nomeEmpresa",
    label: "Nome da Empresa",
  },
  {
    id: "porte",
    label: "Porte",
  },
  {
    id: "cidade",
    label: "Cidade/UF",
  },
  {
    id: "data",
    label: "Data - Hora",
  },
  {
    id: "sugestao",
    label: "Sugestão",
  },
];

function createData(hash, nome, nomeEmpresa, porte, cidade, data, sugestao) {
  return { hash, nome, nomeEmpresa, porte, cidade, data, sugestao };
}

function returnPort(value) {
  switch (value) {
    case 0:
      return "Todos";
    case 1:
      return "Média Empresa";
    case 2:
      return "Microempresa";
    case 3:
      return "Empresa de Pequeno Porte";
    case 4:
      return "Grande Empresa";
    case 5:
      return "Não Aplicável";
    case 99:
      return "MicroEmpreendedor Individual";
    default:
      return "";
  }
}

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  tableWrapper: {
    overflow: "auto",
  },
  acoes: {
    background: "red",
    fontSize: 80,
  },
});

export default function TableSAS(props) {
  const classes = useStyles();
  const page = 0;
  const rowsPerPage = 99;
  const rows = [];

  if (!rows.length) {
    let cont = 0;
    let incrementTable = [];
    props.content.data.map((item, key) => {
      cont++;
      incrementTable = createData(
        cont,
        item.nomeUsuario,
        item.cnpj,
        returnPort(item.porte),
        `${item.cidade}-${item.uf}`,
        item.dataSugestao,
        item.sugestao
      );
      rows.push(incrementTable);
    });
  }

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, key) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={key}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            {!rows.length && (
              <TableRow>
                <TableCell>
                  Nenhum registro de atividades no SAS encontrado!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Paper>
  );
}
